import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { currencyFormatter } from "../helpers";
import { fetchBonusPeriods } from "redux/KPIs/bonusPeriodSlice";
import { getKPIBonusCalculations } from "components/Apis/KPIs";
import toast from "react-hot-toast";
import jsPDF from "jspdf";
import "jspdf-autotable";

const KPIBonusCalculator = () => {
    const quarter = useSelector((state) => state.KPIFilterReducer.quarter);
    const [KPIPeople, setKPIPeople] = useState([]);
    const dispatch = useDispatch();

    // Columns to keep from the KPIBonusPerson Objects.
    // These functions return display values in the UI.
    // For PDF generation, we’ll extract plain text.
    const COLUMNS_TO_KEEP = {
        "service_teams_/_role": (person) =>
            person.service_teams && person.service_teams.length > 0
                ? person.service_teams.map((team) => `${team.name}`).join("\n&")
                : person.role,
        "name": (person) => person.name,
        "company_quarterly_load_count_met": (person) =>
            Math.round(person.kpi_bonus_calculator.company_quarterly_load_count_met) + "%",
        "continuous_improvement": (person) =>
            person.kpi_bonus_calculator.continuous_improvement + "%",
        "service_team_gross_profit_goal_met": (person) =>
            Math.round(person.kpi_bonus_calculator.service_team_gross_profit_goal_met) + "%",
        "expedite_gross_profit_goal_met": (person) =>
            Math.round(person.kpi_bonus_calculator.expedite_gross_profit_goal_met) + "%",
        "service_failures": (person) =>
            Math.round(person.kpi_bonus_calculator.service_failures) + "%",
        "driver_minimums": (person) =>
            Math.round(person.kpi_bonus_calculator.driver_minimums) + "%",
        "bonus_eligibility": (person) =>
            Math.round(person.kpi_bonus_calculator.bonus_eligibility) + "%",
        "quarterly_bonus_payment": (person) =>
            currencyFormatter.format(person.kpi_bonus_calculator.quarterly_bonus_payment),
    };

    useEffect(() => {
        if (quarter) {
            dispatch(fetchBonusPeriods(quarter));
            (async () => {
                try {
                    const response = await getKPIBonusCalculations(quarter);
                    setKPIPeople(response.data.data);
                }
                catch (error) {
                    if (error.response && error.response.status === 403) {
                        toast.error(error.response.data);
                    }
                }
            })();
        }
    }, [quarter, dispatch]);

    if (!(KPIPeople && KPIPeople.length > 0)) {
        return (
            <h3 style={{ display: "flex", justifyContent: "center" }}>
                Members not created yet...
            </h3>
        );
    }

    // Function to format header strings.
    const formatHeader = (header) => {
        return header
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const formattedHeaders = Object.keys(COLUMNS_TO_KEEP).map((header) => formatHeader(header));

    // Function to generate and download a text-based PDF of the table.
    const handleDownloadPdf = () => {
        const doc = new jsPDF("l", "pt", "a4"); // landscape, points, A4

        // Build the table data.
        const tableBody = KPIPeople.map((person) =>
            Object.entries(COLUMNS_TO_KEEP).map(([key, generator]) => generator(person))
        );

        // Use autoTable to create a text table.
        doc.autoTable({
            head: [formattedHeaders],
            body: tableBody,
            startY: 20,
            styles: { fontSize: 8 },
        });

        doc.save("kpi_bonus_calculator.pdf");
    };

    return (
        <>
            <div className="max-wdith-container">
                <div className="table-header kpi-section">
                    <h1>
                        Bonus results
                    </h1>
                    <button
                        onClick={handleDownloadPdf}
                        className="btn-history"
                    >
                        <i class="fa fa-download" aria-hidden="true"></i>
                    </button>

                </div>
                <table className="kpis-goals-table thin bonus-calculator-table striped">
                    <thead>
                        <tr>
                            {formattedHeaders.map((header, index) => (
                                <th key={index}>{header}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {KPIPeople.map((person) => (
                            <tr key={person.id}>
                                {Object.entries(COLUMNS_TO_KEEP).map(([key, generator], idx) => (
                                    <td key={idx}>
                                        {(generator(person) != "0%")
                                            ? generator(person)
                                            : <span className="text-danger">---</span>}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default KPIBonusCalculator;
